import axios from "axios";
import { captureSentryException, getCurrentUser } from "../Helpers/helpers";

export const apiGet = async (url, useToken) => {
  const myHeaders = new Headers();
  if (useToken) {
    const token = localStorage.getItem("token")
    myHeaders.append("Authorization", `Bearer ${token}`);
  }

  const requestOptions = {
    method: "GET",
    headers: myHeaders,
  };

  return await fetch(url, requestOptions)
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        // return 'Token expired!!!'
        return false;
      }
    })
    .then((result) => result)
    .catch((error) => {
      captureSentryException({failed_reason: error.message});
      throw error;
    });
};

export const apiPost = async (url, data, useToken) => {
  const myHeaders = new Headers();

  if (useToken) {
    const token = localStorage.getItem("token")
    myHeaders.append("Authorization", `Bearer ${token}`);
  }

  const requestOptions = {
    method: "POST",
    body: data,
    headers: myHeaders
  };

  return await fetch(url, requestOptions)
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        // return 'Token expired!!!'
        return response.json();
      }
    })
    .then((result) => result)
    .catch((error) => {
      captureSentryException({failed_reason: error.message});
      throw error;
    });
};

export const apiPatch = async (url, data, useToken) => {
  const myHeaders = new Headers();

  if (useToken) {
    const token = localStorage.getItem("token")
    myHeaders.append("Authorization", `Bearer ${token}`);
  }

  const requestOptions = {
    method: "PATCH",
    body: data,
    headers: myHeaders
  };

  return await fetch(url, requestOptions)
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        // return 'Token expired!!!'
        return response.json();
      }
    })
    .then((result) => result)
    .catch((error) => {
      captureSentryException({failed_reason: error.message});
      throw error;
    });
};

export const downloadFile = async (url, file_name = "AI image.png") => {
  const link = document.createElement("a");

  // Set up the link for download
  link.href = url;
  link.download = file_name;

  // Click the link to initiate the download
  link.click();

  document.body.appendChild(link);
  document.body.removeChild(link);
};

export const uploadFileApi = async (url, formData, headers) => {
  try {
    const response = await fetch(url, {
      method: "POST",
      body: formData,
      headers: headers || {},
    });
    if (!response.ok) return null;

    const blob = await response.blob();
    return blob;
  } catch (error) {
    console.error(error);
    captureSentryException({failed_reason : error})
    return null;
  }
};

export const getFile = async (url, headers) => {
  try {
    const response = await fetch(url, {
      method: "GET",
      redirect: "follow",
      headers: headers || {},
    });
    console.log("RESPONSE", response);
    if (!response.ok) return null;

    const blob = await response.blob();
    return blob;
  } catch (error) {
    console.error(error);
    captureSentryException({failed_reason : error})
    return null;
  }
};

export const apiUploadToGoogleDrive = async ({
  blobFile = null,
  base64Image = null,
  file_name = "image.png",
  category_name,
  chunkSize = 800000, //  781.25 KB per chunk ( do not change )
}) => {
  const user = await getCurrentUser();
  const token = localStorage.getItem("token");
  let otherParams = null;

  if (!token || !user || !blobFile || !base64Image) return;
  const folder_name = user?.organization_detail?.name || "imagine.io";

  const GOOGLE_DRIVE_API =
    "https://fd3jfb4nsg2yo4nef67pb7c5dq0dakda.lambda-url.us-east-1.on.aws/";

  try {
    const totalChunks = Math.ceil(base64Image?.length / chunkSize);

    for (let i = 0; i < totalChunks; i++) {
      const chunk = base64Image?.slice(i * chunkSize, (i + 1) * chunkSize);

      const data = {
        file_data: chunk,
        file_name: file_name,
        folder_name: folder_name,
        category_name: category_name,
        chunk_index: i,
        total_chunks: totalChunks,
        total_chunk_size: blobFile?.size,
        ...(i > 0 && otherParams ? { ...otherParams } : {}),
      };
      const response = await fetch(GOOGLE_DRIVE_API, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      if (!response.ok) {
        captureSentryException({failed_reason :`Failed to upload chunk ${i + 1} of ${totalChunks}`})
        throw new Error(`Failed to upload chunk ${i + 1} of ${totalChunks}`);
      }

      const result = await response.json();
      otherParams = {
        upload_url: result?.upload_url,
        start_position: result?.start_position,
        leftover_data_encoded: result?.leftover_data_encoded,
      };
      // console.log(`Response from Lambda for chunk ${i + 1}:`, result);
    }

    // console.log("All chunks sent successfully.");
  } catch (error) {
    captureSentryException({failed_reason : `Error sending image to Lambda: ${error}`})
    console.error("Error sending image to Lambda:", error);
  }
  
};

export async function apiPostImageOnPresignedData(file, presigned_data, onUploadProgress) {
  const formData = new FormData();
  Object.entries(presigned_data.fields).forEach(([k, v]) => {
    formData.append(k, v);
  });

  formData.append('file', file);
  return await axios.post(presigned_data.url, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress,
  });
}
